<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { SmrStayEdition } from '@/maintenance/types'

const { t } = useI18n()

defineProps<{
  stayEdition: SmrStayEdition
}>()

</script>

<template>
  <tr>
    <td>{{ stayEdition.creationDate.format('DD/MM/YYYY à HH:mm:ss') }}</td>
    <td>{{ t("stayEdition.type."+stayEdition.type, stayEdition.type) }}</td>
    <td>{{ stayEdition.target }}</td>
    <td>{{ t("stayEdition.mode."+stayEdition.mode, stayEdition.mode) }}</td>
    <td>{{ stayEdition.username }}</td>
    <td>{{ stayEdition.medicalUnit }}</td>
    <td>{{ stayEdition.weekNb }}</td>
    <td>{{ stayEdition.gme }}</td>
    <td>{{ stayEdition.value }}€</td>
  </tr>
</template>
